import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-171d9f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "swapBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "诊疗方案公布", -1))
const _hoisted_5 = { class: "bakBox" }
const _hoisted_6 = { class: "swapBox" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "img" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgstr" }, " 渗出部位外用莫匹罗星软膏+糠酸莫米松软膏连续 7日 ", -1))
const _hoisted_10 = { class: "box" }
const _hoisted_11 = { class: "img" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgstr" }, " 躯干红斑无渗出处，外用糠酸莫米松软膏7日，配合润肤霜保湿 ", -1))
const _hoisted_13 = { class: "box" }
const _hoisted_14 = { class: "img" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgstr" }, "每日使用莫匹罗星软膏1支+糠酸莫米松软膏1支", -1))
const _hoisted_16 = { class: "box" }
const _hoisted_17 = { class: "img" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgstr" }, "口服盐酸西替利嗪滴剂7滴bid", -1))
const _hoisted_19 = { class: "box" }
const _hoisted_20 = { class: "img" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgstr" }, "连续1周后复诊", -1))
const _hoisted_22 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}
const _hoisted_23 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.1333rem",
        height: ".6667rem",
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_image, {
                width: "1.4667rem",
                height: "1.4667rem",
                src: require('../assets/xiaoicon1.jpg')
              }, null, 8, ["src"])
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_image, {
                width: "1.4667rem",
                height: "1.4667rem",
                src: require('../assets/xiaoicon2.jpg')
              }, null, 8, ["src"])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_image, {
                width: "1.4667rem",
                height: "1.4667rem",
                src: require('../assets/xiaoicon3.jpg')
              }, null, 8, ["src"])
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_van_image, {
                width: "1.4667rem",
                height: "1.4667rem",
                src: require('../assets/xiaoicon4.jpg')
              }, null, 8, ["src"])
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_van_image, {
                width: "1.4667rem",
                height: "1.4667rem",
                src: require('../assets/xiaoicon5.jpg')
              }, null, 8, ["src"])
            ]),
            _hoisted_21
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_van_image, {
          onClick: $options.showPopup,
          width: "2.5733rem",
          height: "2.5733rem",
          src: require('../assets/jixu.png')
        }, null, 8, ["onClick", "src"]),
        _createVNode(_component_van_image, {
          class: "finger",
          width: "1.28rem",
          height: "1.28rem",
          src: require('../assets/dong.gif')
        }, null, 8, ["src"])
      ]),
      _createVNode(_component_van_popup, {
        show: $data.show,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
      }, {
        default: _withCtx(() => [
          ($data.flag)
            ? (_openBlock(), _createBlock(_component_medical, {
                key: 0,
                onOnChanged: $options.updateChanged,
                postaimqus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus"]))
            : _createCommentVNode("", true),
          (!$data.flag)
            ? (_openBlock(), _createBlock(_component_medical, {
                key: 1,
                onOnChanged: $options.updateChanged,
                postaimqus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}